export const AuthorizationSources = {
  PREVIOUSLY_AUTHORIZED: 'PREVIOUSLY_AUTHORIZED'
};